import React from 'react';

export default function ReauthorizationRequired() {
    return (
        <span className={`w-min text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-red-100 text-red-800`}>
            Reauthorization required
        </span>
    );
}
